var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartLinearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15204 21.94C4.00804 17.364 3.43604 15.0773 4.63738 13.5387C5.83738 12 8.19738 12 12.9134 12H19.0867C23.804 12 26.1614 12 27.3627 13.5387C28.564 15.076 27.992 17.3653 26.848 21.94C26.12 24.8507 25.7574 26.3053 24.672 27.1533C23.5867 28 22.0867 28 19.0867 28H12.9134C9.91338 28 8.41338 28 7.32804 27.1533C6.24271 26.3053 5.87871 24.8507 5.15204 21.94Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12.6666L25.0533 9.19325C24.688 7.85325 24.5053 7.18392 24.1307 6.67859C23.7571 6.17654 23.2497 5.78979 22.6667 5.56259C22.08 5.33325 21.3867 5.33325 20 5.33325M6 12.6666L6.94667 9.19325C7.312 7.85325 7.49467 7.18392 7.86933 6.67859C8.2429 6.17654 8.75025 5.78979 9.33333 5.56259C9.92 5.33325 10.6133 5.33325 12 5.33325",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33333C12 4.97971 12.1405 4.64057 12.3905 4.39052C12.6406 4.14048 12.9797 4 13.3333 4H18.6667C19.0203 4 19.3594 4.14048 19.6095 4.39052C19.8595 4.64057 20 4.97971 20 5.33333C20 5.68696 19.8595 6.02609 19.6095 6.27614C19.3594 6.52619 19.0203 6.66667 18.6667 6.66667H13.3333C12.9797 6.66667 12.6406 6.52619 12.3905 6.27614C12.1405 6.02609 12 5.68696 12 5.33333Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartLinearIcon);
export default __webpack_public_path__ + "static/media/cart-linear-icon.f9012be11dc18957fa005d95fe5b062b.svg";
export { ForwardRef as ReactComponent };